// src/components/ui/GinoriCard.tsx
import React from 'react';
import { Paper, PaperProps } from '@mantine/core';

interface GinoriCardProps extends PaperProps {
  children: React.ReactNode;
  elevated?: boolean;
  interactive?: boolean;
}

export function GinoriCard({ 
  children, 
  elevated = false, 
  interactive = false, 
  ...props 
}: GinoriCardProps) {
  return (
    <Paper
      p="xl"
      radius="md"
      style={{
        backgroundColor: 'var(--mantine-color-white)',
        border: '1px solid var(--mantine-color-ginoriNeutral-2)',
        boxShadow: elevated ? '0 8px 24px rgba(0, 0, 0, 0.12)' : '0 1px 3px rgba(0, 0, 0, 0.08)',
        transition: 'all 0.3s ease',
        cursor: interactive ? 'pointer' : 'default',
        ...(interactive && {
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 12px 32px rgba(0, 0, 0, 0.15)',
            borderColor: 'var(--mantine-color-ginoriGold-3)',
          },
        }),
      }}
      {...props}
    >
      {children}
    </Paper>
  );
}
